<template>
  <div class="elementor-shape elementor-shape-bottom" data-negative="false">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 100"
      preserveAspectRatio="none"
      style="background: #eaeaea"
    >
      <path
        style="fill: rgb(76 155 117)"
        d="M0,0c0,0,0,6,0,6.7c0,18,240.2,93.6,615.2,92.6C989.8,98.5,1000,25,1000,6.7c0-0.7,0-6.7,0-6.7H0z"
      ></path>
    </svg>
  </div>
</template>
